import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatPromptSent.meta';

export type UseTrackAgentChatPromptSentParams = {
  message_length: number;
  canvas_id: string;
  thread_id: string;
};

export const useTrackAgentChatPromptSent = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatPromptSent = useCallback(
    (params: UseTrackAgentChatPromptSentParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatPromptSent };
};
